function toggleFAQContent() 
{
  var faqs = document.querySelectorAll('.welleasy-homepage-faq');
  faqs.forEach(function(faq) 
  {
      faq.addEventListener('click', function() 
      {
          var content = faq.querySelector('.welleasy-faq-content');
          var icon = faq.querySelector('.faq-icon');
          content.classList.toggle('welleasy-faq-content-visible');
          icon.classList.toggle('faq-icon-rotate');
      });
  });
}

document.addEventListener('DOMContentLoaded', function() 
{
  toggleFAQContent();
});
